import React, { useState, useEffect } from "react";
import { Row, Col, Card, Typography, Button, message, Divider, Tooltip, Form, Modal, Space, Upload, Empty } from "antd";
import {
  EditOutlined,
  StarOutlined,
  PlusOutlined,
  DeleteFilled,
  SkinOutlined,
  FileImageOutlined,
  StarFilled,
  CameraOutlined,
} from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { RenderImageCard } from "./components/renderImage";
import { useNavigate, useParams } from "react-router-dom";
import http from "../../../services/http";
const { Text } = Typography;

export const UniformesCadProdutosImagens = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, setDados] = useState([]);
  const [showModal, setShowModal] = useState(false);

  // PRODUTO
  const [produto, setProduto] = useState(null);

  useEffect(() => {
    if (id) {
      carregarProduto(id);
      listarProdutosImagens(id);
    }
  }, [id]);

  // CARREGAR PRODUTO
  const carregarProduto = async (id) => {
    if (!id) return;
    setLoading(true);
    const api = await http("get", `v1/uniformes_produtos/carregar/${id}`, []);

    if (api.statusCode === 200) {
      setProduto(api.response.data);
    } else {
      navigate("/uniformes/gestao-produtos");
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // LISTAR
  const listarProdutosImagens = async (id_prod) => {
    setLoading(true);
    const api = await http("get", `v1/uniformes_produtos_imagens/listar/${id_prod}`, []);
    if (api.statusCode === 200) {
      setDados(api.response.data);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // CADASTRAR
  const cadastrarProdutoImagem = async (formulario) => {
    if (!formulario.id_uniformes_cad_produtos) return;
    setLoading(true);
    let erros = 0;

    try {
      for (let arquivo of formulario?.imagens) {
        const formData = new FormData();
        formData.append("id_uniformes_cad_produtos", formulario.id_uniformes_cad_produtos);
        formData.append("file", arquivo.originFileObj);

        const api = await http("post", "v1/uniformes_produtos_imagens/adicionar", formData, "multipart/form-data");
        if (api.statusCode !== 200) {
          message.error(api?.response?.message);
          break;
        }
      }
    } catch (error) {
      message.error("Houve algum erro ao tentar enviar!");
    }

    listarProdutosImagens(id);
    setShowModal(false);
    resetForm();
    setLoading(false);
  };

  // DELETAR
  const deletarProdutoImagem = async (id_delete) => {
    setLoading(true);
    const api = await http("post", `v1/uniformes_produtos_imagens/deletar`, {
      id: id_delete,
    });
    if (api.statusCode === 200) {
      message.success("Registro deletado com sucesso!");
      listarProdutosImagens(id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // FAVORITAR
  const favoritarProdutoImagem = async (id_imagem) => {
    setLoading(true);
    const api = await http("post", `v1/uniformes_produtos_imagens/favoritar`, {
      id: id_imagem,
      id_uniformes_cad_produtos: id,
    });
    if (api.statusCode === 200) {
      listarProdutosImagens(id);
    } else {
      message.error(api.response.message);
    }
    setLoading(false);
  };

  // RESET FORM
  const resetForm = () => {
    form.resetFields();
  };

  // SUBMIT FORM
  const onSubmit = (formulario) => {
    formulario.id_uniformes_cad_produtos = id && id;
    cadastrarProdutoImagem(formulario);
  };

  const formFile = (e) => {
    const isLt2M = e?.file?.size / 1024 / 1024 > 5;
    if (isLt2M) {
      message.error("Tamanho não suportado, máximo 5MB!");
      return null;
    }

    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  // FORMULÁRIO
  const modalFormulario = () => {
    return (
      <Modal
        title={
          <Text style={{ fontSize: 20 }}>
            <EditOutlined /> Nova Imagem
          </Text>
        }
        open={showModal}
        onOk={() => form.submit()}
        okText="Salvar"
        width={1200}
        okButtonProps={{ size: "large", loading: loading }}
        cancelButtonProps={{ size: "large", loading: loading }}
        onCancel={() => {
          setShowModal(false);
          resetForm();
        }}>
        <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col className="gutter-row" span={24}>
              <Form.Item
                name="imagens"
                valuePropName="fileList"
                getValueFromEvent={formFile}
                rules={[{ required: true, message: "Adicione uma imagem!" }]}>
                <Upload.Dragger
                  style={{ maxHeight: 300 }}
                  disabled={loading}
                  multiple
                  beforeUpload={() => false}
                  accept="image/jpeg, image/png">
                  <p className="ant-upload-drag-icon">
                    <FileImageOutlined />
                  </p>
                  <p className="ant-upload-text">Clique ou arraste uma imagem para esta área para fazer upload</p>
                </Upload.Dragger>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  };

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario()}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage title="Uniformes" onClickBack={() => navigate("/uniformes/gestao-produtos")} />
            <HeaderTitle
              title="Uniformes Produtos Imagens"
              subtitle={
                <Text italic>
                  <SkinOutlined /> {produto?.descricao ?? ""}
                </Text>
              }
              icon={<CameraOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <Space direction="vertical" wrap>
                <Tooltip title="Adicionar Registro">
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={() => {
                      setShowModal(true);
                      resetForm();
                    }}
                    loading={loading}>
                    Novo
                  </Button>
                </Tooltip>
              </Space>

              <Divider />

              <Row>
                {dados.map((d, index) => {
                  return (
                    <RenderCard
                      key={d.id}
                      idImagem={d.id}
                      onDelete={() => deletarProdutoImagem(d.id)}
                      onFavorite={() => favoritarProdutoImagem(d.id)}
                      favorite={d.principal === 1 ? true : false}
                    />
                  );
                })}
                {dados?.length === 0 && (
                  <div className="align-center">
                    <Empty />
                  </div>
                )}
              </Row>
            </Card>
          </div>
        </Col>
      </Col>
    </Row>
  );
};

// RENDER CARD
const RenderCard = ({ idImagem, onDelete, onFavorite, favorite }) => {
  const [modal, contextHolder] = Modal.useModal();

  return (
    <Col xs={24} sm={12} md={12} lg={8} xl={8} xxl={6} align="left" style={{ padding: 10 }}>
      <Card
        style={{ width: "100%", maxWidth: "100%" }}
        bodyStyle={{ padding: 0 }}
        actions={[
          <Tooltip title="Excluir">
            <DeleteFilled
              key="delete"
              style={{ fontSize: 22 }}
              onClick={() => {
                modal.confirm({
                  title: "Deseja deletar este registro?",
                  okText: "Sim",
                  cancelText: "Cancelar",
                  onOk() {
                    onDelete();
                  },
                });
              }}
            />
          </Tooltip>,
          <Tooltip title="Definir como Principal">
            {favorite ? (
              <StarFilled key="delete" style={{ fontSize: 22, color: "#ffca00" }} />
            ) : (
              <StarOutlined onClick={onFavorite} key="delete" style={{ fontSize: 22 }} />
            )}
          </Tooltip>,
        ]}>
        <RenderImageCard idImagem={idImagem} />
      </Card>
      {contextHolder}
    </Col>
  );
};
